import { render, staticRenderFns } from "./FFSidelistItem.vue?vue&type=template&id=1df6dee7&scoped=true&"
import script from "./FFSidelistItem.vue?vue&type=script&lang=js&"
export * from "./FFSidelistItem.vue?vue&type=script&lang=js&"
import style0 from "./FFSidelistItem.vue?vue&type=style&index=0&id=1df6dee7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df6dee7",
  null
  
)

export default component.exports